import React, { Component } from 'react';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { HeadContainer, Chips, LevelRowContainer, MainWrapper, RoundedWrapper } from './styles';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Label } from 'components/atoms/Texts/TxtLabel';
import lo from 'lodash';
import { NewDelayedInformationDateTime } from 'fixtures/TemplateData';
import DataTable from 'components/organisms/DataTable/index';
import ButtonReg from 'components/atoms/Buttons/Button';
import { actionFormatter } from 'components/molecules/TableFormatters/actionFormatter';
import { EditFormater } from 'components/molecules/TableFormatters/editFormatter';
import { UNIT_DOZER_EXCAVATORS } from 'fixtures/api';
import { getLookup } from 'Redux/actions/LookupActions';
import FormTxt from 'components/atoms/Inputs/FormTxt';
import { getAllList } from 'services/cmsService';
import moment from 'moment'
import { dateTimeRangePickerFormatter } from 'components/molecules/TableFormatters/dateTimeRangePickerFormatter';

export class ActualLoadingDelayedInformationForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      options: []
    }
  }

  componentDidMount(){
    this.fetchUnitDozer()
  }

  fetchUnitDozer = async () => {
    try {
      this.props.toggleIsLoading(true)
      const data = await getAllList(UNIT_DOZER_EXCAVATORS)
      const newData = data.map(d => ({ unit: d.name, remark: '' }))
      this.props.onChange('loadingDelayedUnit', newData)
    } catch (error) {
      console.error(error);
    } finally {
      this.props.toggleIsLoading(false)
    }
  }

  onChangeDateTime(val, row, field, rowIndex) {
    const { form: { loadingDelayedDateTime }, onChange } = this.props
    const newData = loadingDelayedDateTime.map((d,i) => i === rowIndex ? {
      ...row,
      [field] : field === 'remark' ? val : moment(val).format(),
      ...field === 'timeStart' ? {timeEnd: moment(val).format()} : {}
    } : d)
    onChange('loadingDelayedDateTime', newData)
  }

  add() {
    const { form: { loadingDelayedDateTime }, onChange } = this.props
    const newData = [...loadingDelayedDateTime, lo.cloneDeep(NewDelayedInformationDateTime)]
    onChange('loadingDelayedDateTime', newData)
  }

  delete(row, rowIndex) {
    const { form: { loadingDelayedDateTime }, onChange } = this.props
    const newData = loadingDelayedDateTime.filter((d,i) => i !== rowIndex)
    onChange('loadingDelayedDateTime', newData)
  }

  onChangeUnit(val, row, field, rowIndex) {
    const { form: { loadingDelayedUnit }, onChange } = this.props
    const newData = loadingDelayedUnit.map((d,i) => i === rowIndex ? {
      ...row,
      [field] : val
    } : d)
    onChange('loadingDelayedUnit', newData)
  }

  onChangeInformation(field, val) {
    const { form: { loadingDelayedInformation }, onChange } = this.props
    loadingDelayedInformation[field] = val
    if (['outlookTCM','outlookBEK','blendingMTD'].indexOf(field) > -1){
      loadingDelayedInformation.MTD = Number(loadingDelayedInformation.outlookTCM) + Number(loadingDelayedInformation.outlookBEK) + Number(loadingDelayedInformation.blendingMTD)
    }
    if (['tcm','bek','blendingYTD'].indexOf(field) > -1){
      loadingDelayedInformation.YTD = Number(loadingDelayedInformation.tcm) + Number(loadingDelayedInformation.bek) + Number(loadingDelayedInformation.blendingYTD)
    }
    onChange('loadingDelayedInformation', loadingDelayedInformation)
  }

  renderTextInput(key, placeholder, inputProps) {
    const { form: { loadingDelayedInformation }, theme } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <FormTxt
        placeholder={placeholder}
        value={loadingDelayedInformation ? loadingDelayedInformation[key] : 0}
        onChangeVal={e => this.onChangeInformation(key, e.target.value)}
        {...inputConfig}
        {...inputProps}
      />
    )
  }

  render() {
    const { theme, viewState: { isMobileView }, form: { loadingDelayedDateTime, loadingDelayedUnit, loadingDelayedInformation }, filter: { loadingDate } } = this.props

    const dateTimeConfig = [
      {
        dataField: 'dateTime',
        text: 'Date & Time',
        formatter: dateTimeRangePickerFormatter,
        formatExtraData: {
          placeholder: 'Select date & time',
          fieldStart: 'timeStart',
          fieldEnd: 'timeEnd',
          fn: (val, row, field, rowIndex) => this.onChangeDateTime(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'remark',
        text: 'Remark',
        headerAttrs: { minWidth: 150 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter remark',
          type: 'text',
          field: 'remark',
          fn: (val, row, field, rowIndex) => this.onChangeDateTime(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { minWidth: 100 },
        formatter: actionFormatter,
        formatExtraData: {
          style: { height: '34px', display: 'flex', alignItems: 'center' },
          allowDel: true,
          del: (row, rowIndex) => this.delete.bind(this, row, rowIndex),
        },
        editable: false,
        isDummyField: true
      },
    ]

    const unitConfig = [
      {
        dataField: 'unit',
        text: 'Unit Dozer/Excavator',
        editable: false,
        sort: true
      },
      {
        dataField: 'remark',
        text: 'Remark',
        headerAttrs: { minWidth: 150 },
        formatter: (cell, row, rowIndex, formatExtraData) =>
          <EditFormater {...{cell, row, rowIndex, formatExtraData}}/>,
        formatExtraData: {
          placeholder: 'Enter remark',
          type: 'text',
          field: 'remark',
          fn: (val, row, field, rowIndex) => this.onChangeUnit(val, row, field, rowIndex),
        },
        editable: false,
        sort: true
      },
    ]

    return (
        <RoundedWrapper gap="20px">
          <MainWrapper>
            <HeadContainer>
              <Label lineheight={'29px'} size={'16px'} mb={'0px'}>
                Loading Delayed Information
              </Label>
            </HeadContainer>
              <RoundedWrapper >
                <LevelRowContainer>
                  <DataTable
                    leftSlot={
                      <ButtonReg
                        btnTxt={'Add'}
                        onClick={() => this.add()}
                        width={'78px'}
                      />
                    }
                    allowSearch={false}
                    rightSlotAlt={true}
                    defaultSize={100}
                    isMobile={isMobileView}
                    dataList={loadingDelayedDateTime || []}
                    columnConfig={dateTimeConfig}
                  />
                </LevelRowContainer>
              </RoundedWrapper>
              <RoundedWrapper >
                <LevelRowContainer>
                  <DataTable
                    noHeadings={true}
                    allowSearch={false}
                    rightSlotAlt={true}
                    defaultSize={100}
                    isMobile={isMobileView}
                    dataList={loadingDelayedUnit || []}
                    columnConfig={unitConfig}
                  />
                </LevelRowContainer>
              </RoundedWrapper>
              <LevelRowContainer>
                <RoundedWrapper >
                  <div className='react-bootstrap-table'>
                    <table className='table table-striped table-hover'>
                      <thead>
                        <tr>
                          <th><Label lineheight={'14px'} size={'12px'}>Information</Label></th>
                          <th><Label lineheight={'14px'} size={'12px'}>{`Actual Loading ${moment(loadingDate).format('YYYY')}`}</Label></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Chips
                              background={theme.mocaPurple}
                              shown
                            >
                              <Label
                                color={theme.white}
                                weight={'normal'}
                                size={'12px'}
                              >
                                {`TCM ${moment(loadingDate).format('YYYY')}`}
                              </Label>
                            </Chips>
                          </td>
                          <td>
                            {this.renderTextInput('tcm', 'Enter actual loading')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label weight={'normal'} size={'12px'}>
                              {`Plan Budget ${moment(loadingDate).format('MMM YYYY')}`}
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('planBudgetTCM', 'Enter actual loading')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label weight={'normal'} size={'12px'}>
                              {`Outlook ${moment(loadingDate).format('MMM YYYY')}`}
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('outlookTCM', 'Enter actual loading')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Chips
                              background={theme.mocaOrange}
                              shown
                            >
                              <Label
                                color={theme.white}
                                weight={'normal'}
                                size={'12px'}
                              >
                                {`BEK ${moment(loadingDate).format('YYYY')}`}
                              </Label>
                            </Chips>
                          </td>
                          <td>
                            {this.renderTextInput('bek', 'Enter actual loading')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label weight={'normal'} size={'12px'}>
                              {`Plan Budget ${moment(loadingDate).format('MMM YYYY')}`}
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('planBudgetBEK', 'Enter actual loading')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label weight={'normal'} size={'12px'}>
                              {`Outlook ${moment(loadingDate).format('MMM YYYY')}`}
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('outlookBEK', 'Enter actual loading')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label size={'12px'} color={theme.mocaGreen}>
                              Total Blending TCM & BEK (MTD)
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('totalBlending', 'Enter total blending')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label weight={'normal'} size={'12px'}>
                              Blending TCM & BEK (MTD)
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('blendingMTD', 'Enter blending MTD')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Label weight={'normal'} size={'12px'}>
                              Blending TCM & BEK (YTD)
                            </Label>
                          </td>
                          <td>
                            {this.renderTextInput('blendingYTD', 'Enter blending MTD')}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Chips
                              background={theme.mocaPurple}
                              shown
                            >
                              <Label
                                color={theme.white}
                                weight={'normal'}
                                size={'12px'}
                              >
                                TCM
                              </Label>
                            </Chips>
                            {` + `}
                            <Chips
                              background={theme.mocaOrange}
                              shown
                            >
                              <Label
                                color={theme.white}
                                weight={'normal'}
                                size={'12px'}
                              >
                                BEK
                              </Label>
                            </Chips>
                            <Label weight={'normal'} size={'12px'}>
                              &nbsp; MTD
                            </Label>
                          </td>
                          <td>
                            <Label size={'12px'} color={theme.mocaGreen}>
                              {loadingDelayedInformation ? (loadingDelayedInformation.MTD && loadingDelayedInformation.MTD.toLocaleString()) : 0}
                            </Label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Chips
                              background={theme.mocaPurple}
                              shown
                            >
                              <Label
                                color={theme.white}
                                weight={'normal'}
                                size={'12px'}
                              >
                                TCM
                              </Label>
                            </Chips>
                            {` + `}
                            <Chips
                              background={theme.mocaOrange}
                              shown
                            >
                              <Label
                                color={theme.white}
                                weight={'normal'}
                                size={'12px'}
                              >
                                BEK
                              </Label>
                            </Chips>
                            <Label weight={'normal'} size={'12px'}>
                              &nbsp; YTD
                            </Label>
                          </td>
                          <td>
                            <Label size={'12px'} color={theme.mocaGreen}>
                              {loadingDelayedInformation ? (loadingDelayedInformation.YTD && loadingDelayedInformation.YTD.toLocaleString()) : 0}
                            </Label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </RoundedWrapper>
              </LevelRowContainer>
          </MainWrapper>
        </RoundedWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ActualLoadingDelayedInformationForm)
  )
);
